<template>
  <div id="player-container" :class="playerActiveClass">
    <div id="player-content">
      <div v-if="!ready" id="spinner-loading-wrapper" :style="backgroundStyle">
        <div class="profile-main-loader">
          <div class="loader">
            <svg class="circular-loader" viewBox="25 25 50 50">
              <circle
                class="loader-path"
                cx="50"
                cy="50"
                r="20"
                fill="none"
                stroke="$new_white"
                stroke-width="2"
              />
            </svg>
          </div>
        </div>
      </div>
      <div id="videoCollectionWrapper">
        <vueVimeoPlayer
          ref="collectionVideoPlayer"
          :video-id="collectionItem.video"
          :loop="true"
          :autoplay="true"
          @ready="onPlayerReady"
          :class="{fullscreenDeactive: !this.isFullscreen}"
        ></vueVimeoPlayer>
      </div>
    </div>
  </div>
</template>

<script>
import { Fragment } from "vue-fragment";
import { mapState } from "vuex";
import { vueVimeoPlayer } from "vue-vimeo-player";

export default {
  name: "Home",
  components: {
    Fragment,
    vueVimeoPlayer
  },
  computed: {
    ...mapState(["global"]),
    primaryBackgroundColor(){
      return `--primary_background_color: ${this.$store.getters.themeSettings.primary_background_color};`;
    },
    secondaryBackgroundColor(){
      return `--secondary_background_color: ${this.$store.getters.themeSettings.secondary_background_color};`;
    },
    backgroundStyle() {
      return `${this.primaryBackgroundColor} ${this.secondaryBackgroundColor}`;
    },
  },
  data() {
    return {
      options: {
        background: false
      },
      playerReady: false,
      playerActiveClass: "",
      muted: true,
      ready: false,
      isFullscreen: false
    };
  },
  props: {
    collectionItem: {
      type: Object,
      required: true
    }
  },
  mounted() {
    if (this.collectionItem) {
      this.adjustPlayerSize();
    }
    window.addEventListener('resize', this.isFullscreenFunction)
  },
  methods: {
    onPlayerReady() {
      this.$refs.collectionVideoPlayer.play();
      this.ready = true;
    },
    adjustPlayerSize() {
      if (this.collectionItem.ultra_wide) {
        let playerContainer = document.getElementById("player-container");
        let playerContent = document.getElementById("player-content");

        playerContainer.style.height = "41.6vw";
        playerContent.style.height = "41.6vw";
      }
    },
    isFullscreenFunction(){ 
      this.isFullscreen =  1 >= outerHeight - innerHeight ? true : false
    }
  }
};
</script>

<style lang="scss" scoped>
#player-container {
  width: 100vw;
  height: 56.25vw;
  max-height: 100vh;
  // height: 41.6vw;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  z-index: 0;
  transition: all 0.5s ease-in-out;
  background: #000;
  #home-image {
    height: 100%;
    width: 100%;
    object-fit: cover;
    z-index: 0;
    position: absolute;
  }
  #videoCollectionWrapper {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    z-index: 0;
  }
  #player-content {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    width: 100%;
    height: 56.25vw;
    max-height: 100vh;
    z-index: 0;
    transition: background 0.9s ease-in-out;
    background: #000;
    display: flex;
    justify-content: center;
    align-items: center;
    .home-title {
      h1 {
        opacity: 0.5;
        font-family: "AvenirLTStd-Black";
        font-size: 24px;
        color: #c7c7c7;
        letter-spacing: 2px;
        text-align: center;
        text-transform: uppercase;
        display: none;
      }
    }
  }
  // #paralax-spacer {
  //   width: 100%;
  //   height: 100vh;
  //   position: fixed;
  //   top: 0;
  //   left: 0;
  //   z-index: 0;
  //   transition: background 0.9s ease-in-out;
  // }
  .controls {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: row;
    position: absolute;
    bottom: 0;
    right: 0;
    left: 0;
    width: 100%;
    height: 50px;
    background: transparent;
    padding: 18px;
    .button {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: row;

      cursor: pointer;
    }
    .muteButton {
    }
    .pauseButton {
    }
  }
}

#spinner-loading-wrapper {
  width: 100%;
  height: 100%;
  background-color: $new_black;
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
  .profile-main-loader {
    z-index: 9000 !important;
    .loader {
      position: relative;
      margin: 0px auto;
      width: 200px;
      height: 200px;
    }
    .loader:before {
      content: "";
      display: block;
      padding-top: 100%;
    }

    .circular-loader {
      -webkit-animation: rotate 2s linear infinite;
      animation: rotate 2s linear infinite;
      height: 100%;
      -webkit-transform-origin: center center;
      -ms-transform-origin: center center;
      transform-origin: center center;
      width: 100%;
      position: absolute;
      top: 0;
      left: 0;
      margin: auto;
    }

    .loader-path {
      stroke-dasharray: 150, 200;
      stroke-dashoffset: -10;
      -webkit-animation: dash 1.5s ease-in-out infinite,
        color 6s ease-in-out infinite;
      animation: dash 1.5s ease-in-out infinite, color 6s ease-in-out infinite;
      stroke-linecap: round;
    }

    @-webkit-keyframes rotate {
      100% {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg);
      }
    }

    @keyframes rotate {
      100% {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg);
      }
    }
    @-webkit-keyframes dash {
      0% {
        stroke-dasharray: 1, 200;
        stroke-dashoffset: 0;
      }
      50% {
        stroke-dasharray: 89, 200;
        stroke-dashoffset: -35;
      }
      100% {
        stroke-dasharray: 89, 200;
        stroke-dashoffset: -124;
      }
    }
    @keyframes dash {
      0% {
        stroke-dasharray: 1, 200;
        stroke-dashoffset: 0;
      }
      50% {
        stroke-dasharray: 89, 200;
        stroke-dashoffset: -35;
      }
      100% {
        stroke-dasharray: 89, 200;
        stroke-dashoffset: -124;
      }
    }
    @-webkit-keyframes color {
      0% {
        stroke: var(--primary_background_color);
      }
      40% {
        stroke: var(--primary_background_color);
      }
      66% {
        stroke: var(--primary_background_color);
      }
      80%,
      90% {
        stroke: var(--primary_background_color);
      }
    }
    @keyframes color {
      0% {
        stroke: var(--primary_background_color);
      }
      40% {
        stroke: var(--primary_background_color);
      }
      66% {
        stroke: var(--primary_background_color);
      }
      80%,
      90% {
        stroke: var(--primary_background_color);
      }
    }
  }
}
</style>
<style lang="scss">
#videoCollectionWrapper {
  .fullscreenDeactive iframe {
    width: 100vw;
    height: auto;
    min-height: 100vh;
    max-width: 100vw;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>